export enum HatType {
    Helmet = "Helmet_mesh",
    Cylinder = "Cylinder_mesh",
    Pirate = "Pirate_mesh",
    Cap = "Cap_mesh"
}
